import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=9625ac8e&scoped=true&"
import script from "./ColorSelector.vue?vue&type=script&lang=ts&"
export * from "./ColorSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=9625ac8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9625ac8e",
  null
  
)

export default component.exports